const facilityTypeColors = [
    'rgba(215, 248, 250, 1)',
    'rgba(212, 236, 213, 1)',
    'rgba(255, 223, 228, 1)',
    'rgba(190, 0, 221, 0.1)',
    'rgba(254, 234, 191, 1)',
    'rgba(231, 223, 255, 1)',
    'rgba(247, 199, 248, 1)',
    'rgba(187, 230, 255, 1)',
];

export {facilityTypeColors};